import RevertIcon from "@husky-hrc/Components/Icons/RevertIcon";
import { InputModel } from "@husky-hrc/Framework/Types/ApiModel";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";

export interface RevertStyles {
    clickableStyles?: ClickablePresentationProps;
    iconStyles?: IconPresentationProps;
    textStyles?: TypographyPresentationProps;
}

export const revertStyles: RevertStyles = {
    clickableStyles: {
        css: css`
            margin-left: auto;
            color: ${getColor("text.disabled")};
            display: flex;
            flex-direction: column;
            &:active {
                svg,
                svg > * {
                    stroke: ${getColor("danger.main")};
                }
                span {
                    color: ${getColor("danger.main")};
                }
            }
        `,
    },
    iconStyles: {
        size: 16,
        src: RevertIcon,
    },
    textStyles: {
        size: 12,
        lineHeight: "15px",
        css: css`
            letter-spacing: 0.7px;
            color: ${getColor("text.main")};
            opacity: 0.8;
            white-space: nowrap;
        `,
    },
};
interface OwnProps {
    input: InputModel;
    onUncommit: (parameter: string) => void;
}

type Props = OwnProps;

const styles = revertStyles;

const RevertButton = ({ input, onUncommit }: Props) => {
    const handleClick = () => {
        onUncommit(input.name);
    };
    return (
        <Clickable {...styles.clickableStyles} onClick={handleClick}>
            <Icon {...styles.iconStyles} />
            <Typography {...styles.textStyles}>{translate("Revert")}</Typography>
        </Clickable>
    );
};

export default RevertButton;
